import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AlertsHistorical } from '../../../../../shared/types/legalProceedings/alerts';
import { MOTIVE } from '../../../../../routes/paths';
import {
    asyncGetMotive,
    asyncGetMotiveHistorical,
} from '../../../../../services/param.service';
import { Motive } from '../../../../../shared/types/systemConfiguration/motives';

export const useMotiveDetail = () => {
    const [showHistorical, setShowHistorical] = useState(false);
    const navigate = useNavigate();
    const { name, active } = useParams();
    const [loading, setLoading] = useState(false);
    const [motive, setMotive] = useState<Motive>();
    const [motiveHistorical, setMotiveHistorical] =
        useState<AlertsHistorical[]>();

    useEffect(() => {
        if (Boolean(name)) {
            setLoading(true);
            asyncGetMotive(name, active)
                .then((motive) => {
                    if (motive) setMotive((motive as any)?.items);
                    else navigate(MOTIVE);
                })
                .finally(() => setLoading(false));
        }
    }, [name]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetMotiveHistorical(name, active)
                .then((resp) => {
                    if (resp) setMotiveHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        loading,
        motive,
        motiveHistorical,
        showHistorical,
        setShowHistorical,
    };
};
